export const ColorProps = {
  'text.1': {
    light: '#193766',
  },
}
